










































import { Component, Vue } from 'vue-property-decorator';
import { ProjectTaskEditModel } from '@/services/api/nswag/stapiclient_generated';
import { stProjectTaskApi } from '@/services/st-api';
import StRatePicker from '@/components/basic/StRatePicker.vue';
import SlideIn from '@/components/basic/SlideIn.vue';
import StInput2 from '@/components/basic/StInput2.vue';
import StToggle from '@/components/basic/StToggle.vue';
import { notifySuccess } from '@/utlitities/notifications';
import StExplanation from '@/components/basic/StExplanation.vue';
import {UserStore} from '@/store/user-module';

@Component({
  components: {
    StExplanation,
    StToggle,
    StInput2,
    SlideIn,
    StRatePicker,
  },
})
export default class ProjectTaskEdit extends Vue {
  private id: number = 0;
  private projectTask: ProjectTaskEditModel = ProjectTaskEditModel.fromJS({ name: '' });
  private loading: boolean = true;
  private saving: boolean = false;
  private listPage: string = 'ProjectTasks';

  openSlideIn() {
    (this.$refs.slideIn as SlideIn).open();
  }

  closeSlideIn() {
    (this.$refs.slideIn as SlideIn).close();
  }

  slideOutClosed() {
    this.$router.push({ name: this.listPage });
  }

  created() {
    this.id = parseInt(this.$route.params.id);
  }

  async mounted() {
    this.openSlideIn();
    this.projectTask = this.id == 0 ? await stProjectTaskApi.getNew() : await stProjectTaskApi.get(this.id);
    this.loading = false;
  }

  get canViewRates() {
    return UserStore.userSettings.CanViewRates && !UserStore.userSettings.noRates;
  }

  async submit() {
    try {
      this.saving = true;
      if (this.projectTask.id == 0) {
        await stProjectTaskApi.post(this.projectTask);
      } else {
        await stProjectTaskApi.put(this.projectTask.id, this.projectTask);
      }
      notifySuccess('Erfolgreich gespeichert');
      this.closeSlideIn();
    } finally {
      this.saving = false;
    }
  }
}
